import useTingStore from '../../stores/tingStore';
import React from 'react';
import { Button, TextField, Typography } from '@mui/material';
import { generateChildPath } from '../../utils/firebase/uploadPhoto';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { db, storage } from '../../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import './Media.css';

export default function Media() {
    const tingDoc = useTingStore(state => state.tingDoc);
    const [selectedPhoto, setSelectedPhoto] = React.useState(null);
    const [transferred, setTransferred] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [uploaded, setUploaded] = React.useState(false);

    const imageWidth = Number(tingDoc?.imageWidth);
    const imageHeight = Number(tingDoc?.imageHeight);
    const aspectRatio = (
        Number.isFinite(imageWidth) &&
        Number.isFinite(imageHeight) &&
        imageWidth > 0 &&
        imageHeight > 0
    )
        ? imageWidth / imageHeight
        : 4 / 3;

    const handleSingleFileChange = (e) => {
        console.log('Selected photo:', e.target.files[0]);
        setSelectedPhoto(e.target.files[0]);
        setUploaded(false);
    };

    const uploadFile = async (file, path, setProgress) => {
        return new Promise((resolve, reject) => {
            const fileRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(fileRef, file);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const percent = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    setProgress(percent);
                },
                (err) => reject(err),
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((url) => resolve(url));
                }
            );
        });
    };


    const handleUpload = async () => {
        if (!selectedPhoto) return;

        setLoading(true);
        setTransferred(0);
        try {
            console.log('Ting doc:', tingDoc);
            const tingRef = doc(db, 'posts', tingDoc.postId);
            console.log('Ting ref:', tingRef.path);
            const tingSnap = await getDoc(tingRef);
            console.log('Ting snap:', tingSnap.data());

            if (tingSnap.exists()) {
                const tingData = tingSnap.data();

                const photoChildPath = generateChildPath(tingData, selectedPhoto);
                console.log('Photo child path:', photoChildPath);

                const photoURL = selectedPhoto ? await uploadFile(selectedPhoto, photoChildPath, setTransferred) : tingData.postImg;


                await updateDoc(tingRef, {
                    postImg: photoURL,
                    contentType: 'image',
                    updatedTime: new Date(),
                    postVideo: null,
                });

                setUploaded(true);
                // Refresh the page
                window.location.reload();

            } else {
                console.error('No such document!');
            }
        } catch (error) {
            console.error('Error uploading photos:', error);
        }
        setLoading(false);
    };

    return (
        <div className="ting-media">
            {(tingDoc?.postImg || tingDoc?.postVideo) ? (
                <div className="ting-media__preview" style={{ aspectRatio: `${aspectRatio}` }}>
                    {tingDoc?.postImg && (
                        <img
                            className="ting-media__asset"
                            src={tingDoc.postImg}
                            alt="Ting"
                        />
                    )}
                    {tingDoc?.postVideo && (
                        <video
                            className="ting-media__asset"
                            src={tingDoc.postVideo}
                            controls
                        />
                    )}
                </div>
            ) : (
                <Typography variant="body2" className="ting-media__empty">
                    No media is attached to this ting yet.
                </Typography>
            )}

            <div className="ting-media__controls">
                <Typography variant="h6">Change Photo</Typography>
                <TextField
                    type="file"
                    onChange={handleSingleFileChange}
                    inputProps={{ accept: 'image/*' }}
                    size="small"
                    fullWidth
                />
                <Button
                    disabled={loading || !selectedPhoto}
                    variant="contained"
                    color="primary"
                    onClick={handleUpload}
                >
                    {loading ? 'Uploading...' : 'Upload'}
                </Button>
                <Typography variant="body2" className="ting-media__progress">
                    {loading && `${transferred}% uploaded`}
                    {!loading && uploaded && 'Upload complete.'}
                    {!loading && !uploaded && !selectedPhoto && 'Choose a photo to upload.'}
                    {!loading && !uploaded && selectedPhoto && 'Ready to upload.'}
                </Typography>
            </div>
        </div>
    );
}
